// extracted by mini-css-extract-plugin
export default {"modalContent":"modal-winner_modalContent__YdeUK","modalText":"modal-winner_modalText__uinuL","modalTextTitle":"modal-winner_modalTextTitle__gf-1c"};